module.exports = {
  github: "https://github.com/GShadowBroker",
  linkedin:
    "https://www.linkedin.com/in/gledyson-ferreira-dos-santos-69a1791b4/",
  email: "mailto:gledysonferreira@gmail.com",
}
